import React from 'react';
import { Container } from 'react-bootstrap';


const GoogleMapsEmbed = ({stream}) => {
    return (
        <>
            <Container className="my-5">
                <div
                    style={{
                        overflow: "hidden",
                        boxShadow:
                            "rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px",
                    }}
                >
                    <iframe
                        title="Google Maps location"
                        width="100%"
                        height="350"
                        style={{ border: 0 }}
                        src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyBFI_deSl8kWdpmRHh-0aVmaKpoJA2b02U&q=${
                            stream &&
                            encodeURIComponent(stream.metadata.address)
                        }&zoom=10`}
                        allowFullScreen
                    ></iframe>
                </div>
            </Container>
        </>
    );
}

export default GoogleMapsEmbed;